var _rect, _rect2, _g, _rect3, _rect4, _rect5, _rect6, _g2, _path, _g3, _path2, _g4, _circle, _circle2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelayNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 90,
    viewBox: "0 0 118 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_949_3634)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#137FFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0875 14.0009C20.5055 13.9883 19.9278 14.1028 19.3947 14.3365C18.8615 14.5702 18.3858 14.9174 18.0007 15.354C17.6156 15.7906 17.3305 16.3059 17.1652 16.864C16.9999 17.4222 16.9584 18.0097 17.0436 18.5856C17.1288 19.1614 17.3387 19.7117 17.6586 20.1981C17.9784 20.6844 18.4006 21.0951 18.8956 21.4014C19.3906 21.7077 19.9465 21.9023 20.5245 21.9716C21.1025 22.0408 21.6886 21.9831 22.242 21.8024C22.3366 21.7715 22.415 21.7044 22.46 21.6157C22.505 21.5269 22.5129 21.424 22.482 21.3294C22.4511 21.2349 22.3839 21.1565 22.2952 21.1115C22.2065 21.0665 22.1036 21.0585 22.009 21.0894C21.4077 21.2858 20.7621 21.3024 20.1515 21.1372C19.5408 20.972 18.9917 20.6322 18.5713 20.1594C18.151 19.6866 17.8778 19.1015 17.7852 18.4757C17.6926 17.8499 17.7847 17.2107 18.0501 16.6365C18.3155 16.0623 18.7427 15.578 19.2793 15.243C19.8159 14.908 20.4387 14.737 21.0711 14.7508C21.7035 14.7646 22.3182 14.9626 22.8397 15.3207C23.3612 15.6787 23.7669 16.1812 24.007 16.7664C24.0447 16.8585 24.1175 16.9318 24.2092 16.9701C24.2547 16.9892 24.3034 16.999 24.3526 16.9992C24.4019 16.9994 24.4507 16.9899 24.4963 16.9712C24.5418 16.9525 24.5833 16.925 24.6182 16.8903C24.6532 16.8556 24.681 16.8144 24.7 16.769C24.719 16.7235 24.7289 16.6748 24.729 16.6256C24.7292 16.5763 24.7197 16.5275 24.701 16.4819C24.4055 15.7616 23.9062 15.1431 23.2644 14.7024C22.6225 14.2617 21.8659 14.0179 21.0875 14.0009ZM21.375 15.8749C21.375 15.7755 21.3355 15.6801 21.2652 15.6098C21.1949 15.5395 21.0995 15.4999 21 15.4999C20.9006 15.4999 20.8052 15.5395 20.7349 15.6098C20.6645 15.6801 20.625 15.7755 20.625 15.8749V17.8449L19.608 18.8614C19.5712 18.8958 19.5416 18.9372 19.5211 18.9832C19.5006 19.0292 19.4896 19.0788 19.4887 19.1292C19.4878 19.1795 19.4971 19.2296 19.516 19.2762C19.5348 19.3229 19.5629 19.3654 19.5985 19.401C19.6341 19.4366 19.6765 19.4646 19.7232 19.4835C19.7699 19.5024 19.8199 19.5116 19.8703 19.5107C19.9206 19.5099 19.9703 19.4988 20.0163 19.4783C20.0623 19.4578 20.1037 19.4283 20.138 19.3914L21.265 18.2649L21.375 18.1549V15.8749ZM24.5 21.4999C24.5 21.6326 24.4473 21.7597 24.3536 21.8535C24.2598 21.9473 24.1326 21.9999 24 21.9999C23.8674 21.9999 23.7402 21.9473 23.6465 21.8535C23.5527 21.7597 23.5 21.6326 23.5 21.4999C23.5 21.3673 23.5527 21.2402 23.6465 21.1464C23.7402 21.0526 23.8674 20.9999 24 20.9999C24.1326 20.9999 24.2598 21.0526 24.3536 21.1464C24.4473 21.2402 24.5 21.3673 24.5 21.4999ZM24.375 18.3749C24.375 18.2755 24.3355 18.1801 24.2652 18.1098C24.1949 18.0395 24.0995 17.9999 24 17.9999C23.9006 17.9999 23.8052 18.0395 23.7349 18.1098C23.6645 18.1801 23.625 18.2755 23.625 18.3749V20.1249C23.625 20.2244 23.6645 20.3198 23.7349 20.3901C23.8052 20.4604 23.9006 20.4999 24 20.4999C24.0995 20.4999 24.1949 20.4604 24.2652 20.3901C24.3355 20.3198 24.375 20.2244 24.375 20.1249V18.3749Z",
    fill: "#EEF9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_949_3634)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 63,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.9
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 69,
    width: 12,
    height: 12,
    rx: 2,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 73,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_949_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 62.2652C58.8813 62.4116 59.1187 62.4116 59.2652 62.2652L61.6517 59.8787C61.7981 59.7322 61.7981 59.4948 61.6517 59.3484C61.5052 59.2019 61.2678 59.2019 61.1213 59.3484L59 61.4697L56.8787 59.3484C56.7322 59.2019 56.4948 59.2019 56.3483 59.3484C56.2019 59.4948 56.2019 59.7322 56.3483 59.8787L58.7348 62.2652ZM58.625 54V55.5H59.375V54H58.625ZM58.625 56.5V59.5H59.375V56.5H58.625ZM58.625 60.5V62H59.375V60.5H58.625Z",
    fill: "#7DB9FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7348 62.2652C58.8813 62.4116 59.1187 62.4116 59.2652 62.2652L61.6517 59.8787C61.7981 59.7322 61.7981 59.4948 61.6517 59.3484C61.5052 59.2019 61.2678 59.2019 61.1213 59.3484L59 61.4697L56.8787 59.3484C56.7322 59.2019 56.4948 59.2019 56.3483 59.3484C56.2019 59.4948 56.2019 59.7322 56.3483 59.8787L58.7348 62.2652ZM58.625 54V57.3333H59.375V54H58.625ZM58.625 58.6667V62H59.375V58.6667H58.625Z",
    fill: "#42CFEF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_949_3634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 36",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30L59 36",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "4 1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_949_3634)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 44.75,
    r: 8.25,
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.751,
    cy: 44.75,
    r: 8.25,
    stroke: "#42CFEF",
    strokeWidth: 0.5,
    strokeMiterlimit: 3.99933,
    strokeDasharray: "3 1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.75,
    cy: 44.75,
    r: 6.75,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7203 42.0517V47.4517C61.7203 47.5949 61.6634 47.7323 61.5621 47.8336C61.4608 47.9348 61.3235 47.9917 61.1803 47.9917H59.8303C59.6871 47.9917 59.5497 47.9348 59.4484 47.8336C59.3472 47.7323 59.2903 47.5949 59.2903 47.4517V42.0517C59.2903 41.9085 59.3472 41.7712 59.4484 41.6699C59.5497 41.5686 59.6871 41.5117 59.8303 41.5117H61.1803C61.3235 41.5117 61.4608 41.5686 61.5621 41.6699C61.6634 41.7712 61.7203 41.9085 61.7203 42.0517ZM57.6703 41.5117H56.3203C56.1771 41.5117 56.0397 41.5686 55.9384 41.6699C55.8372 41.7712 55.7803 41.9085 55.7803 42.0517V47.4517C55.7803 47.5949 55.8372 47.7323 55.9384 47.8336C56.0397 47.9348 56.1771 47.9917 56.3203 47.9917H57.6703C57.8135 47.9917 57.9508 47.9348 58.0521 47.8336C58.1534 47.7323 58.2103 47.5949 58.2103 47.4517V42.0517C58.2103 41.9085 58.1534 41.7712 58.0521 41.6699C57.9508 41.5686 57.8135 41.5117 57.6703 41.5117Z",
    fill: "#394353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_949_3634",
    x: 0,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_949_3634",
    result: "effect2_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_949_3634",
    result: "effect3_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_949_3634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_949_3634",
    x: 0,
    y: 57,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_949_3634",
    result: "effect2_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_949_3634",
    result: "effect3_dropShadow_949_3634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_949_3634",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_949_3634",
    x: 48.2383,
    y: 46,
    width: 21.5234,
    height: 24.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_949_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_949_3634",
    x: 50.625,
    y: 22,
    width: 16.75,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_949_3634"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_949_3634",
    x: 47.126,
    y: 33.125,
    width: 23.25,
    height: 23.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_949_3634"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_3634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayNode);
export default __webpack_public_path__ + "static/media/delayNode.518ab1732e377a65e6ac9e3d01fefe1d.svg";
export { ForwardRef as ReactComponent };